import { useNavigate, useLocation } from "react-router-dom"

import { useState, useContext, useRef, useReducer, useEffect, useMemo } from "react";
import QRCode from "react-qr-code";

import { Context } from "../../App";

import { AiOutlineDownload } from "react-icons/ai";
import { IoCopyOutline } from "react-icons/io5";
import { IoCopy } from "react-icons/io5";
import { TbCopyCheckFilled } from "react-icons/tb";

import { Oval } from 'react-loader-spinner'
import ReactGA from "react-ga4";


function AddUserQR({ }) {
  const navigate = useNavigate();
  // const location = useLocation()
  const {
    generatedCodeC,
    nameC, } = useContext(Context);

  const [generatedCode, setGeneratedQrCode] = generatedCodeC
  const [name, setName] = nameC;

  const [copyHover, setCopyHover] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [copyURLHover, setCopyURLHover] = useState(false);
  const [isURLcoped, setisURLcoped] = useState(false);

  const [QRHover, setQRHover] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [isAnimClose, setIsAnimClose] = useState(false);
  const [isAnimCloseBottom, setIsAnimCloseBottom] = useState(false);
  const [isHidden, setIsHidden] = useState(false);


  const [showLargeQR, setshowLargeQR] = useState(false);


  // const [generatedCode, setGeneratedQrCode] = generatedQrCodeContext;

  useEffect(() => {

    if (generatedCode === "") {
      navigate("/G");
    }
    else setIsLoading(false)
  }, [])

  const handleCodeCopy = () => {
    try {
      navigator.clipboard.writeText(generatedCode);
      setIsCopied(true)
    } catch (error) {
      // console.log(error);
    }
  }

  const handleURLCopy = () => {
    try {
      navigator.clipboard.writeText("channect.com/O/" + generatedCode)
      setisURLcoped(true)
    } catch (error) {
      // console.log(error);
    }
  }

  const downloadQR = () => {
    // const canvas = document.getElementById("custom-qr");
    // const pngUrl = canvas
    //   .toDataURL("image/png")
    //   .replace("image/png", "image/octet-stream");
    // let downloadLink = document.createElement("a");
    // downloadLink.href = pngUrl;
    // downloadLink.download = "123456.png";
    // document.body.appendChild(downloadLink);
    // downloadLink.click();
    // document.body.removeChild(downloadLink);
  };


  return (
    <div className={`w-full flex flex-col ${isLoading ? "justify-center" : "justify-between"}  items-center md:px-[50px] pt-4 pb-4 rounded-md h-full overflow-y-auto`}>
      {/*  */}
      {isLoading ?
        <Oval
          visible={true}
          height="80"
          width="80"
          color="#b01ba7"
          secondaryColor="#bda9bc"
          ariaLabel="oval-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
        :
        <>

          <div className="flex flex-col items-center md:px-11 pb-11 h-[calc(100%-69px)] rounded-md  w-full h-full">

            <div className="md:mt-4 ffb px-5 md:px-7 py-3 text-center text-headPrimary text-lg md:text-2xl font-bold ">
              {name} Created Successfully
            </div>

            <div className="flex justify-center w-full mt-4">
              <div className={`flex flex-col justify-between h-full ${showLargeQR ? "w-full" : "w-[670px]"} `}>
                {
                  // isLoading ?
                  //     <div className="grow flex items-center flex-col justify-center px-5 py-5">
                  //         <Oval
                  //             visible={true}
                  //             height="60"
                  //             width="60"
                  //             color="#1665ff"
                  //             secondaryColor="#fff"
                  //             ariaLabel="oval-loading"
                  //             wrapperStyle={{}}
                  //             wrapperClass=""
                  //         />
                  //     </div>
                  //     :
                  <>
                    <div className="ffb w-full  px-7  mt-4 flex flex-col gap-4 justify-start items-center">

                      <p className="uppercase text-gray-500">
                        {/* RSVP # */}
                      </p>

                      <p className="text-5xl text-headPrimary font-medium leading-9 flex items-center">
                        <span >{generatedCode}</span>


                        <div
                          onClick={handleCodeCopy}
                          onMouseEnter={() => { setCopyHover(true) }}
                          onMouseLeave={() => { setCopyHover(false) }}
                          className="ml-4 cursor-pointer">
                          {isCopied ?
                            <TbCopyCheckFilled className="h-9 w-9" />
                            :
                            copyHover ?
                              <IoCopy className="h-9 w-9" />
                              :
                              <IoCopyOutline className="h-9 w-9" />
                          }

                        </div>

                      </p>

                      {/* <button
                        onMouseEnter={() => { setCopyURLHover(true) }}
                        onMouseLeave={() => { setCopyURLHover(false) }}
                        onClick={handleURLCopy}
                        className="w-[220px] border border-headPrimary text-headPrimary flex items-center justify-between hover:font-bold hover:bg-lightPrimary py-0.5 px-1.5 rounded-md text-base">
                        <span className="">channect.com/U/{generatedCode}</span>

                        <div
                          onClick={handleCodeCopy}
                          className="ml-2 cursor-pointer">
                          {isURLcoped ?
                            <TbCopyCheckFilled className="h-4 w-4" />
                            :
                            copyURLHover ?
                              <IoCopy className="h-4 w-4" />
                              :
                              <IoCopyOutline className="h-4 w-4" />
                          }

                        </div>
                      </button> */}

                      <div className=" flex flex-col items-center mt-3">

                        <div
                          onClick={() => { setshowLargeQR(true) }}

                          onMouseEnter={() => { setQRHover(true) }}
                          onMouseLeave={() => { setQRHover(false) }}
                          className={`relative flex flex-col items-center w-fit cursor-pointer`}>

                          <QRCode
                            id="custom-qr"
                            size={256}
                            fgColor="#329e5f"
                            style={{ height: "auto", maxWidth: "220px", width: "220px", opacity: QRHover ? "0.3" : '1' }}
                            value={"website.com/O/" + generatedCode}
                            viewBox={`0 0 256 256`}
                          />



                          {QRHover &&

                            <div className="absolute mx-auto top-[87px] bg-headPrimary text-white opacity-100 rounded-md left-0 right-0 flex text-center p-0.5 uppercase text-sm w-fit justify-center cursor-pointer">
                              < AiOutlineDownload
                                onClick={downloadQR}
                                className="w-10 h-10" />
                            </div>
                          }


                        </div>
                      </div>


                      <button
                        onClick={() => { navigate('/GURU') }}
                        className=" mt-8 flex items-center justify-center py-2 w-[220px] bg-white rounded-md border text-xl text-headPrimary hover:text-white hover:bg-headPrimary shadow-md hover:shadow-lg hover:font-bold">
                        Return To Dashboard
                      </button>
                    </div>

                  </>
                }


              </div>
            </div>
          </div>
        </>}
    </div>
  )
}

export default AddUserQR
